const appVariablesUrl = '/settings/config.json';

export default appVariablesUrl;
